export const useScreenshotStore = defineStore("screenshot", () => {
  const isCapturingScreenshot = ref(false);

  return {
    isCapturingScreenshot,
  };
});
